"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEST_IDS = exports.ERROR_IMAGE_ID_UX4 = exports.DEFAULT_ERROR_MSG_DETAILS = void 0;
exports.DEFAULT_ERROR_MSG_DETAILS = {
    TITLE: "Uh-oh!",
    MESSAGE: "Sorry! This should not have happened. Please retry.",
    CTA: "Retry",
};
exports.ERROR_IMAGE_ID_UX4 = "4_0_Assets/ux4_empty_cart_500";
exports.TEST_IDS = {
    CTA: "generic-error-page-cta",
    BACK_ICON: "generic-error-page-back_btn",
};
